export default __webpack_public_path__ + "static/media/select-arrow.aeba7f58.svg";